import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel, { EmblaCarouselType } from "embla-carousel-react";

import { useResize } from "@hooks/useResize";

import { ScrollZoneComponent } from "./ScrollZone.types";
import * as Styled from "./ScrollZone.styled";

export const ScrollZone: ScrollZoneComponent = props => {
  const count = React.Children.count(props.children);
  const [hasSroll, setHasSroll] = useState(false);

  const $list = React.useRef<HTMLDivElement | null>(null);

  const { windowWidth } = useResize();

  const [scrollProgress, setScrollProgress] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
  });

  const onScroll = useCallback((emblaApi: EmblaCarouselType) => {
    const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
    setScrollProgress(progress * 100);
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onScroll(emblaApi);
    emblaApi.on("reInit", onScroll);
    emblaApi.on("scroll", onScroll);
  }, [emblaApi, onScroll]);

  useEffect(() => {
    const scrollContainer = emblaApi ? emblaApi.rootNode() : $list.current;

    if (!scrollContainer) {
      return;
    }
    const hasHorizontalScrollbar =
      scrollContainer.scrollWidth > scrollContainer.clientWidth;

    setHasSroll(hasHorizontalScrollbar);
  }, [windowWidth, emblaApi]);

  return (
    <Styled.Root
      className={props.className}
      ref={hasSroll ? emblaRef : $list}
      {...(props.isSection ? { as: "section" } : {})}
    >
      <Styled.ScrollContainer isCentered={!hasSroll}>
        {props.children}
      </Styled.ScrollContainer>
      <Styled.Scroll isVisible={hasSroll}>
        <Styled.ScrollBar
          elementsCount={count}
          style={{
            transform: `translateX(${(count - 1) * scrollProgress}%)`,
          }}
        />
      </Styled.Scroll>
    </Styled.Root>
  );
};

ScrollZone.SlideContainer = Styled.SlideContainer;
